export class ActivityLogItem {
    id: number;
    staff_id_fk: number;
    athlete_id_fk: number;
    activity_timestamp: string;
    activity_timestamp_date: string;
    activity_timestamp_time: string;
    admin_first_name: string;
    admin_last_name: string;
    role_type_title: string;
    athlete_log_type_label: string;
    activity_log_type_id_fk: number;
    athlete_first_name: string;
    athlete_last_name: string;
    notes: string;

    constructor() { }


}


// WEBPACK FOOTER //
// ./src/app/_models/activityLogItem.model.ts